import { Component, OnInit } from '@angular/core';
import {AdminsDashboardService} from "../../service/admins-dashboard.service";
import {LoginResponse} from "../../../authentication/models/login-response.dto";
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';

@Component({
  selector: 'app-admins-dashboard',
  templateUrl: './admins-dashboard.component.html',
  styleUrls: ['./admins-dashboard.component.scss']
})
export class AdminsDashboardComponent implements OnInit {

  dashboardDetails: any;
  stpCounts: any;
  
  applicationPermissions = applicationPermissions;
  constructor(private adminsDashboardService: AdminsDashboardService) {


  }

  ngOnInit(): void {
    let currentUserInfo: LoginResponse = JSON.parse(localStorage.getItem('currentUserInfo') ?? '{}');

    if (currentUserInfo?.id != null) {
      this.getDashboardDetails(currentUserInfo?.id);
      this.getStpCounts();
    };
  }


  getDashboardDetails(userId: any) {
    this.adminsDashboardService.getAdminsDashboardDetails(userId).subscribe({
      next: (res: any) => {
        this.dashboardDetails = res.data;

      }
    });
  }

  getStpCounts() {
    this.adminsDashboardService.getStpCounts().subscribe({
      next: (res: any) => {
        this.stpCounts = res.data;

      }
    });
  }

}
